import { ApplicationState } from '~/store/store';

export const getAdditionalLoadState = (state: ApplicationState) => state.room.data.additionalLoad;
